"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var FetchWithTimeout_1 = require("./FetchWithTimeout");
var HTTPMethod;
(function (HTTPMethod) {
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["POST"] = "POST";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["GET"] = "GET";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["PATCH"] = "PATCH";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["PUT"] = "PUT";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["DELETE"] = "DELETE";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["HEAD"] = "HEAD";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["CONNECT"] = "CONNECT";
    // eslint-disable-next-line no-unused-vars
    HTTPMethod["TRACE"] = "TRACE";
})(HTTPMethod = exports.HTTPMethod || (exports.HTTPMethod = {}));
var RequestBuilder = /** @class */ (function () {
    function RequestBuilder(route, debug) {
        if (debug === void 0) { debug = false; }
        this.debug = debug;
        this.route = '';
        this.body = null;
        this.headers = new Headers();
        this.method = HTTPMethod.GET;
        this.mode = null;
        this.errorHandling = null;
        this.timeout = FetchWithTimeout_1.DEFAULT_TIMEOUT;
        this.route = route;
        return this;
    }
    RequestBuilder.prototype.withErrorHandling = function (callback) {
        this.errorHandling = callback;
        return this;
    };
    RequestBuilder.prototype.withBody = function (body) {
        if (body === void 0) { body = {}; }
        this.body = body;
        return this;
    };
    RequestBuilder.prototype.withHeaders = function (headers) {
        this.headers = headers;
        return this;
    };
    RequestBuilder.prototype.withMethod = function (method) {
        this.method = method;
        return this;
    };
    RequestBuilder.prototype.withMode = function (mode) {
        this.mode = mode;
        return this;
    };
    RequestBuilder.prototype.withTimeout = function (timeout) {
        this.timeout = timeout;
        return this;
    };
    RequestBuilder.prototype.request = function () {
        if (this.debug) {
            var debugHeaders_1 = {};
            this.headers.forEach(function (value, key) {
                debugHeaders_1[key] = value;
            });
            // eslint-disable-next-line no-console
            console.log('will request: ', this.route, this.method, JSON.stringify(debugHeaders_1), JSON.stringify(this.body));
        }
        var opts = {
            method: this.method,
            headers: this.headers,
        };
        if (this.mode)
            opts.mode = this.mode;
        if (this.method !== HTTPMethod.GET &&
            this.method !== HTTPMethod.HEAD &&
            this.body)
            opts.body = JSON.stringify(this.body);
        return FetchWithTimeout_1.fetchWithTimeout(this.route, opts, this.timeout);
    };
    RequestBuilder.prototype.build = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, res, contentType, success, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.request()];
                    case 1:
                        res = _a.sent();
                        contentType = res.headers.get('content-type');
                        success = res.ok;
                        status = res.status;
                        if (!(contentType && contentType.indexOf('application/json') !== -1)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, res.text()];
                    case 4:
                        result = (_a.sent());
                        _a.label = 5;
                    case 5:
                        if (this.debug)
                            // eslint-disable-next-line no-console
                            console.log('request yielded: ', result, ' was it successfull? ', success ? 'yes' : 'no');
                        if (!success && this.errorHandling)
                            this.errorHandling(result, status);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return RequestBuilder;
}());
exports.RequestBuilder = RequestBuilder;
//# sourceMappingURL=RequestBuilder.js.map